export default function(t){return function(n){var r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"0,0";return t(n).format(r)}}
//# sourceMappingURL=vue-filter-number-format.esm.min.js.map
